export default __webpack_public_path__ + "static/media/logo-dev-concierge-2.02393eca.svg";